import React, { useEffect, useState, useRef } from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import { MdVideoLibrary } from "react-icons/md";
// import img1 from "../../Assests_Url/image-teach.png";
// import img2 from "../../Assests_Url/image-video.png";
// import Interactive from '../../Assests_Url/InterExer.png'
import ques from "../../Assests_Url/question.png";
import pers from "../../Assests_Url/gridicons.png";
import aisearch from "../../Assests_Url/ai.png";
import coverage from "../../Assests_Url/cov-report.png";
import mul_search from "../../Assests_Url/multi-search.png";
import { RiVolumeUpFill } from "react-icons/ri";
import { PiExamFill } from "react-icons/pi";
import { FaLanguage } from "react-icons/fa6";

import img1 from "../../Assests_Url/UTeach_1st/Concept & Explanation/1. Concept Video within base book.png";
import img2 from "../../Assests_Url/UTeach_1st/Concept & Explanation/2.Both base book and Concept video.png";
import img3 from "../../Assests_Url/UTeach_1st/Concept & Explanation/3. Explanation Video within base book.png";
import img4 from "../../Assests_Url/UTeach_1st/Concept & Explanation/4. Filteration of Metaconten.png";
import img5 from "../../Assests_Url/UTeach_1st/Concept & Explanation/5.Unit  or chapter selection.png";
import img6 from "../../Assests_Url/UTeach_1st/Concept & Explanation/6. Resource Selection.png";
import img7 from "../../Assests_Url/UTeach_1st/Concept & Explanation/7. Search result.png";
import img8 from "../../Assests_Url/UTeach_1st/Concept & Explanation/8. Searched  explantion videi.png";
import img9 from "../../Assests_Url/UTeach_1st/Concept & Explanation/9. Full view Mode.png";

import img11 from "../../Assests_Url/UTeach_1st/intractive exc/1. Fill in the blanks with audio input.png";
import img12 from "../../Assests_Url/UTeach_1st/intractive exc/2. Type the answer then Check.png";

import img21 from "../../Assests_Url/UTeach_1st/INTERACTIVE QUIZZ/1. Chapter wise Self- Assessment.png";
import img22 from "../../Assests_Url/UTeach_1st/INTERACTIVE QUIZZ/2. Student answer and correct answer.bmp";
import img23 from "../../Assests_Url/UTeach_1st/INTERACTIVE QUIZZ/3. Student answer.bmp";

import img31 from "../../Assests_Url/UTeach_1st/Audio/1.Open a page in the Unit.png";
import img32 from "../../Assests_Url/UTeach_1st/Audio/2.Tap on any sentence or word to   Listen Audio.bmp.png";
import img33 from "../../Assests_Url/UTeach_1st/Audio/3.Audio tools is availabe.bmp.png";

import img41 from "../../Assests_Url/UTeach_1st/PERSONALISATION/1.Tap on Notes in the menu on selection of a text.png";
import img42 from "../../Assests_Url/UTeach_1st/PERSONALISATION/2.Notes - Select color  and submit.png";
import img43 from "../../Assests_Url/UTeach_1st/PERSONALISATION/3.Notes - entered.png";
import img44 from "../../Assests_Url/UTeach_1st/PERSONALISATION/4.Notes - Enter content and Save.png";
import img45 from "../../Assests_Url/UTeach_1st/PERSONALISATION/5.Highlight -Menu item.png";
import img46 from "../../Assests_Url/UTeach_1st/PERSONALISATION/6.Highlight - Select color and Submit.png";
import img47 from "../../Assests_Url/UTeach_1st/PERSONALISATION/7.Highlight - listed after creation.png";
import img48 from "../../Assests_Url/UTeach_1st/PERSONALISATION/8.Bookmark - creation.png";
import img49 from "../../Assests_Url/UTeach_1st/PERSONALISATION/9.Book mark - add content and save.png";
import img40 from "../../Assests_Url/UTeach_1st/PERSONALISATION/10.Bookmark - Save and  listing.png";

import img51 from "../../Assests_Url/UTeach_1st/Dictionary & Translate/1. Inbuilt Dictionary.png";
import img52 from "../../Assests_Url/UTeach_1st/Dictionary & Translate/2.  Dictionary View.png";
import img53 from "../../Assests_Url/UTeach_1st/Dictionary & Translate/3.Inbuilt Translator.png";
import img54 from "../../Assests_Url/UTeach_1st/Dictionary & Translate/4. Language seletion.png";
import img55 from "../../Assests_Url/UTeach_1st/Dictionary & Translate/5. Selected text is translated to hindi.png";

import img61 from "../../Assests_Url/UTeach_1st/AI/1. AI is integrated.bmp";
import img62 from "../../Assests_Url/UTeach_1st/AI/2.Multiple AI is Available.bmp";
import img63 from "../../Assests_Url/UTeach_1st/AI/3.Reposnse from ChatGPT.bmp";
import img64 from "../../Assests_Url/UTeach_1st/AI/4.Reposnse from Perplexity.bmp";

import img71 from "../../Assests_Url/UTeach_1st/Coverage Report/1.After using the KATBOOK.png";
import img72 from "../../Assests_Url/UTeach_1st/Coverage Report/1.Before using the KATBOOK.png";

import img81 from "../../Assests_Url/UTeach_1st/MULTIPLE SEARCH/1.Text selection.png";
import img82 from "../../Assests_Url/UTeach_1st/MULTIPLE SEARCH/2.Search engine selection.png";
import img83 from "../../Assests_Url/UTeach_1st/MULTIPLE SEARCH/3. Bing search result.png";
import img84 from "../../Assests_Url/UTeach_1st/MULTIPLE SEARCH/4. Selection of AI search from  in the same page.png";
import img85 from "../../Assests_Url/UTeach_1st/MULTIPLE SEARCH/5. Deepseek search result.png";
import img86 from "../../Assests_Url/UTeach_1st/MULTIPLE SEARCH/6. Enclopedia search result.png";
import img87 from "../../Assests_Url/UTeach_1st/MULTIPLE SEARCH/7.Select Translate from the menu.png";
import img88 from "../../Assests_Url/UTeach_1st/MULTIPLE SEARCH/8.Select the language  Arabic - View the result.png";

import { IoArrowUndoCircle } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import inter_Exer from "../../Assests_Url/Interactive_Img.png";
import Audio from "../../Assests_Url/Audio_Img.png";
import personal from "../../Assests_Url/Personalisation_Img.png";
import inter_quiz from "../../Assests_Url/INTERACTIVE QUIZZ_common.jpg";
import Carousel from "../Carousel/Carousel";

const UTeachFoundation = ({
  RoutesClick,
  NcertClick,
  selectedLang,
  setSelectedLang,
  allCountries
}) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const lang = searchParams.get("lang") || "en";

  const [registerModal, setRegisterModal] = useState(false);
  const [activeTabHeader, setActiveTabHeader] = React.useState("KATBOOK");
  const [studentregisterModal, setStudentRegisterModal] = useState(false);
  const [ParentregisterModal, setParentRegisterModal] = useState(false);
  const [TeacherregisterModal, setTeacherregisterModal] = useState(false);
  const [AdminregisterModal, setAdminregisterModal] = useState(false);
  const handleTabClickHeader = (tab) => {
    setActiveTabHeader(tab);
  };

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();

  const v1 = useRef(null);
  const v2 = useRef(null);
  const v3 = useRef(null);
  const v4 = useRef(null);
  const v5 = useRef(null);
  const v6 = useRef(null);
  const v7 = useRef(null);
  const v8 = useRef(null);
  const v9 = useRef(null);

  const pauseOthers = (current) => {
    [v1, v2, v3, v4, v5, v6, v7, v8, v9].forEach((ref) => {
      if (ref.current && ref.current !== current) {
        ref.current.pause();
      }
    });
  };

  const sampleData1 = [
    {
      img: img1,
      title: "Concept Video within base book",
    },
    {
      img: img2,
      title: "Both base book and Concept video",
    },
    {
      img: img3,
      title: "Explanation Video within base book",
    },
    {
      img: img4,
      title: "Filteration of Meta content",
    },
    {
      img: img5,
      title: "Unit or chapter selection",
    },
    {
      img: img6,
      title: "Resource Selection",
    },
    {
      img: img7,
      title: "Search result",
    },
    {
      img: img8,
      title: "Searched explanation video",
    },
    {
      img: img9,
      title: "Full view mode",
    },
  ];

  const sampleData2 = [
    {
      img: img11,
      title: "Fill in the blanks with audio input",
    },
    {
      img: img12,
      title: "Type the answer and check",
    },
  ];

  const sampleData3 = [
    {
      img: img21,
      title: "Chapter wise Self - Assessment",
    },
    {
      img: img22,
      title: "Student answer and correct answer",
    },
    {
      img: img23,
      title: "Student answer",
    },
  ];

  const sampleData4 = [
    {
      img: img31,
      title: "Open a page in the Unit",
    },
    {
      img: img32,
      title: "Tap on any sentence or word to Listen Audio",
    },
    {
      img: img33,
      title: "Audio tools is available",
    },
  ];

  const sampleData5 = [
    {
      img: img41,
      title: "Tap on Notes in the menu on selection of a text",
    },
    {
      img: img42,
      title: "Notes - Select color and submit",
    },
    {
      img: img43,
      title: "Notes - Entered",
    },
    {
      img: img44,
      title: "Notes - Enter content and Save",
    },
    {
      img: img45,
      title: "Highlight - Menu item",
    },
    {
      img: img46,
      title: "Highlight - Select color and Submit",
    },
    {
      img: img47,
      title: "Highlight - Listed after creation",
    },
    {
      img: img48,
      title: "Bookmark - Creation",
    },
    {
      img: img49,
      title: "Bookmark - Add content and save",
    },
    {
      img: img40,
      title: "Bookmark - Save and listing",
    },
  ];

  const sampleData6 = [
    {
      img: img51,
      title: "Inbuilt Dictionary",
    },
    {
      img: img52,
      title: "Dictionary View",
    },
    {
      img: img53,
      title: "Inbuilt Translator",
    },
    {
      img: img54,
      title: "Language Selection",
    },
    {
      img: img55,
      title: "Selected text is translated to hindi",
    },
  ];

  const sampleData7 = [
    {
      img: img61,
      title: "AI is integrated",
    },
    {
      img: img62,
      title: "Multiple AI is Available",
    },
    {
      img: img63,
      title: "Response from ChatGPT",
    },
    {
      img: img64,
      title: "Response from Perplexity",
    },
  ];

  const sampleData8 = [
    {
      img: img71,
      title: "After using the KATBOOK",
    },
    {
      img: img72,
      title: "Before using the KATBOOK",
    },
  ];

  const sampleData9 = [
    {
      img: img81,
      title: "Text selection",
    },
    {
      img: img82,
      title: "Search engine selection",
    },
    {
      img: img83,
      title: "Bing search result",
    },
    {
      img: img84,
      title: "Selection of AI search from in the same page",
    },
    {
      img: img85,
      title: "Deepseek search result",
    },
    {
      img: img86,
      title: "Enclopedia search result",
    },
    {
      img: img87,
      title: "Select Translate from the menu",
    },
    {
      img: img88,
      title: "Select the language Arabic - View the result",
    },
  ];

  return (
    <div>
      <div>
        <Header
          activeTab={activeTabHeader}
          handleTabClick={handleTabClickHeader}
          studentregisterModal={studentregisterModal}
          setStudentRegisterModal={setStudentRegisterModal}
          ParentregisterModal={ParentregisterModal}
          setParentRegisterModal={setParentRegisterModal}
          TeacherregisterModal={TeacherregisterModal}
          setTeacherregisterModal={setTeacherregisterModal}
          AdminregisterModal={AdminregisterModal}
          setAdminregisterModal={setAdminregisterModal}
          registerModal={registerModal}
          setRegisterModal={setRegisterModal}
          RoutesClick={RoutesClick}
          NcertClick={NcertClick}
          selectedLang={selectedLang}
          setSelectedLang={setSelectedLang}
          allCountries={allCountries}
        />
      </div>

      <div className="container-uteach">
        <div className="pt-5">
          <div className="d-flex align-items-center justify-content-between text-center pb-4">
            <div>
              <IoArrowUndoCircle
                size={30}
                className="back-arrow"
                onClick={() => {
                  navigate("/katbook", { state: { scroll: "bottom" } });
                }}
              />
            </div>
            <div className="found-font">
              {lang === "en"
                ? "UTeach Foundation Level"
                : lang === "hi"
                ? "यूटीच फाउंडेशन लेवल"
                : null}
            </div>
            <div></div>
          </div>

          <div className="d-flex flex-column align-items-center gap-3 pb-4">
            <div className="text-foun-font text-center">
              {lang === "en"
                ? "When logged into a Foundation level KATBOOK, the following features and benefits will be shown:"
                : lang === "hi"
                ? "फाउंडेशन लेवल कैटबुक में लॉग इन करने पर, निम्नलिखित सुविधाएँ और लाभ दिखाई देंगे:"
                : null}{" "}
            </div>
          </div>
          <div className="d-flex flex-column align-items-center gap-3">
            <div className="meta-font">
              {lang === "en"
                ? "The Power of Meta Content"
                : lang === "hi"
                ? "मेटा कंटेंट की शक्ति"
                : null}{" "}
            </div>
            <div className="text-foun-font text-center">
              {lang === "en"
                ? "NCERT KATBOOKS are powered by state-of-the-art additional teaching resources curated by Subject Matter Experts and top content creators from across the globe."
                : lang === "hi"
                ? "एनसीईआरटी कैटबुक दुनिया भर के विषय विशेषज्ञों और शीर्ष कंटेंट निर्माताओं द्वारा तैयार किए गए अत्याधुनिक अतिरिक्त शिक्षण संसाधनों द्वारा संचालित हैं।"
                : null}{" "}
            </div>
            <div className="text-foun-font text-center">
              {lang === "en"
                ? "Teachers can use these ready-to-use additional digital resources to teach in the classroom and improve concept understanding for complex topics."
                : lang === "hi"
                ? "शिक्षक कक्षा में पढ़ाने और जटिल विषयों की अवधारणा समझ को बेहतर बनाने के लिए इन तैयार अतिरिक्त डिजिटल संसाधनों का उपयोग कर सकते हैं।"
                : null}{" "}
            </div>
          </div>

          <div className="pt-5">
            <div className="d-flex flex-column gap-5">
              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="d-flex align-items-center gap-3 cont-heading">
                    1.{" "}
                    {lang === "en"
                      ? "Embedded Videos (Concept & Explanation)"
                      : lang === "hi"
                      ? "एम्बेडेड वीडियो (अवधारणा और स्पष्टीकरण)"
                      : null}{" "}
                    <MdVideoLibrary size="25" className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {lang === "en"
                      ? "Videos are embedded from the KATBOOK itself to explain difficult or important concepts. By tapping on the play button, a concept video starts directly inside the book window, without redirecting to YouTube or any external platform. Teachers can pause, replay, or project it in full screen. Longer concept videos are available with timestamps for focused teaching."
                      : lang === "hi"
                      ? "कठिन या महत्वपूर्ण अवधारणाओं को समझाने के लिए कैटबुक में ही वीडियो एम्बेड किए जाते हैं। प्ले बटन पर टैप करने से, एक कॉन्सेप्ट वीडियो सीधे बुक विंडो के अंदर शुरू हो जाता है, बिना यू-ट्यूब या किसी बाहरी प्लेटफ़ॉर्म पर रीडायरेक्ट हुये। शिक्षक इसे बीच में रोक कर दिखा सकते हैं, फिर से चला सकते हैं या फ़ुल स्क्रीन में प्रोजेक्ट कर सकते हैं। केंद्रित शिक्षण के लिए टाइमस्टैम्प के साथ लंबे कॉन्सेप्ट वीडियो उपलब्ध हैं। "
                      : null}{" "}
                    <ul>
                      <li>
                        {lang === "en"
                          ? "It acts as a ready-made visual teaching aid for abstract or tough concepts, making class more interactive."
                          : lang === "hi"
                          ? "यह अमूर्त या कठिन अवधारणाओं के लिए एक तैयार दृश्यात्मक शिक्षण सहायता के रूप में कार्य करता है, जिससे कक्षा अधिक परस्‍पर संवादात्‍मक (इंटरैक्टिव) हो जाती है।"
                          : null}{" "}
                      </li>
                      <li>
                        {lang === "en"
                          ? "Saves preparation time — no need to source or create separate videos"
                          : lang === "hi"
                          ? "तैयारी का समय बचाता है - अलग से वीडियो बनाने या स्रोत करने की आवश्यकता नहीं है"
                          : null}{" "}
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData1} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    <video
                      ref={v1}
                      className="video-css"
                      controls
                      onPlay={() => pauseOthers(v1.current)}
                    >
                      <source
                        src={
                          "https://cdn.katbook.com/assets/sites/ncert/758982409034272768_CONCEPTANDEXPLANATIONT1.mp4"
                        }
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="d-flex align-items-center gap-3 cont-heading">
                    2.{" "}
                    {lang === "en"
                      ? "Interactive Exercise"
                      : lang === "hi"
                      ? "इंटरैक्टिव अभ्यास"
                      : null}{" "}
                    <PiExamFill size={25} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {lang === "en"
                      ? "At the end of various sessions, interactive exercises are available in the KATBOOK. Teachers can launch interactive activities like draw and color, drag-and-drop, or matching tasks. In a classroom, teachers can ask students to come up to the smartboard and complete the interactive exercise."
                      : lang === "hi"
                      ? "विभिन्न सत्रों के अंत में, KATBOOK  में इंटरैक्टिव अभ्यास उपलब्ध हैं। शिक्षक चित्र बनाने और रंग भरने, ड्रैग-एंड-ड्रॉप या मिलान कार्यों जैसी इंटरैक्टिव गतिविधियाँ शुरू कर सकते हैं। कक्षा में, शिक्षक छात्रों को स्मार्टबोर्ड पर आकर संवादात्‍मक (इंटरैक्टिव) अभ्यास पूरा करने के लिए प्रोत्साहित कर सकते हैं।"
                      : null}{" "}
                    <ul>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Promotes self learning"
                          : lang === "hi"
                          ? "स्व-शिक्षण को बढ़ावा देता है"
                          : null}{" "}
                      </li>
                      <li>
                        {lang === "en"
                          ? "Children love to tap and explore and this functionality improves classroom participation"
                          : lang === "hi"
                          ? "बच्चों को टैप करना और खोजना पसंद है और यह कार्यक्षमता कक्षा में उनकी सहभागिता को बेहतर बनाती है।"
                          : null}{" "}
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData2} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    <video
                      ref={v2}
                      className="video-css"
                      width="540"
                      controls
                      onPlay={() => pauseOthers(v2.current)}
                    >
                      <source
                        src={
                          "https://cdn.katbook.com/assets/sites/ncert/758982319561379840_INTERACTIVEEXERCISET2.mp4"
                        }
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="d-flex align-items-center gap-3 cont-heading">
                    3.{" "}
                    {lang === "en"
                      ? "Interactive Quizzes in KATBOOK"
                      : lang === "hi"
                      ? "कैटबुक में इंटरैक्टिव क्विज़"
                      : null}{" "}
                    <img src={ques} width={"2%"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {lang === "en"
                      ? "KATBOOK comes with a wide range of built-in quizzes — including multiple choice, fill-in-the-blanks, and short or long answer formats. Teachers can seamlessly use these quizzes during classroom sessions to make learning more engaging while conducting real-time evaluations."
                      : lang === "hi"
                      ? "कैट बुक में कई तरह की अंतर्निहित क्विज़ उपलब्ध हैं — जिनमें बहुविकल्पीय, रिक्त स्थान भरने वाले और लघु या दीर्घ उत्तर वाले प्रश्न शामिल हैं। शिक्षक कक्षा सत्रों के दौरान इन क्विज़ का सहजता से उपयोग कर सकते हैं ताकि वास्तविक समय में मूल्यांकन करते हुए सीखने को और अधिक रोचक बनाया जा सके।"
                      : null}{" "}
                    <ul>
                      <li>
                        {lang === "en"
                          ? "Teachers can launch quizzes live during lessons for instant evaluation, keeping students active, involved, and excited to learn!"
                          : lang === "hi"
                          ? "शिक्षक तत्काल मूल्यांकन के लिए कक्षाओं के दौरान लाइव क्विज़ शुरू कर सकते हैं, जिससे छात्र सक्रिय, शामिल और सीखने के लिए उत्साहित रहेंगे!"
                          : null}{" "}
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData3} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    <video
                      ref={v3}
                      className="video-css"
                      width="540"
                      controls
                      onPlay={() => pauseOthers(v3.current)}
                    >
                      <source
                        src="https://cdn.katbook.com/assets/sites/ncert/758982343120785408_INTERACTIVEQUIZZT3.mp4"
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex flex-column align-items-center gap-3 pt-5">
            <div className="meta-font">
              {" "}
              {lang === "en"
                ? "INTERACTIVE FEATURES OF KATBOOK"
                : lang === "hi"
                ? "कैटबुक की संवादात्‍मक (इंटरैक्टिव) विशेषताएँ"
                : null}{" "}
            </div>
            <div className="text-foun-font text-center">
              {lang === "en"
                ? "At UEducate, we believe that education should go beyond textbooks - it should inspire curiosity, foster understanding, and support every learner’s unique journey. NCERT KATBOOKs transform traditional learning materials into a dynamic and interactive experience that empowers both teachers and students."
                : lang === "hi"
                ? "यू-एजुकेट में, हमारा मानना है कि शिक्षा पाठ्यपुस्तकों से आगे बढ़नी चाहिए - यह जिज्ञासा को प्रेरित करे, समझ को बढ़ावा दे और प्रत्येक शिक्षार्थी की अनूठी यात्रा में सहायक हो। एनसीईआरटी कैटबुक पारंपरिक शिक्षण सामग्री को एक गतिशील और इंटरैक्टिव अनुभव में बदल देती है जो शिक्षकों और छात्रों दोनों को सशक्त बनाती है।"
                : null}{" "}
            </div>
            <div className="text-foun-font text-center">
              {lang === "en"
                ? "Foundational books are equipped with Audio Book mode that can be toggled on and off from the top."
                : lang === "hi"
                ? "मूलभूत पुस्तकें ऑडियो बुक मोड से सुसज्जित हैं जिसे ऊपर से चालू और बंद किया जा सकता है।"
                : null}{" "}
            </div>
          </div>

          <div className="pt-5">
            <div className="d-flex flex-column gap-5">
              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="d-flex align-items-center gap-3 cont-heading">
                    1.{" "}
                    {lang === "en"
                      ? "Audio Book Mode: ON"
                      : lang === "hi"
                      ? "ऑडियो बुक मोड: चालू"
                      : null}{" "}
                    <RiVolumeUpFill size={"20px"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {lang === "en"
                      ? "When switched on, teachers can simply tap on any word/sentence, and the stories or poems come to life with audio."
                      : lang === "hi"
                      ? "चालू होने पर, शिक्षक किसी भी शब्द/वाक्य पर टैप कर सकते हैं, और कहानियाँ या कविताएँ ऑडियो के साथ जीवंत हो जाती हैं।"
                      : null}{" "}
                    <ul>
                      <li>
                        {lang === "en"
                          ? "Quickly teaches right pronunciation and makes the sessions interactive."
                          : lang === "hi"
                          ? "सही उच्चारण जल्दी सिखाता है और सत्रों को इंटरैक्टिव बनाता है।"
                          : null}{" "}
                      </li>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Helps in multilingual classrooms"
                          : lang === "hi"
                          ? "बहुभाषी कक्षाओं में मदद करता है।"
                          : null}{" "}
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData4} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    <video
                      ref={v4}
                      className="video-css"
                      width="540"
                      controls
                      onPlay={() => pauseOthers(v4.current)}
                    >
                      <source
                        src={
                          "https://cdn.katbook.com/assets/sites/ncert/758982408723894272_AudioAndTouchT4.mp4"
                        }
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="d-flex align-items-center gap-2 cont-heading">
                    2.{" "}
                    {lang === "en"
                      ? "Personalisation"
                      : lang === "hi"
                      ? "निजीकरण"
                      : null}{" "}
                    <img src={pers} width={"2%"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {lang === "en"
                      ? "Teachers can highlight key passages, add notes for reference, and bookmark lessons from within the KATBOOK itself."
                      : lang === "hi"
                      ? "शिक्षक मुख्य अंशों को हाइलाइट कर सकते हैं, संदर्भ के लिए नोट्स जोड़ सकते    हैं, और KATBOOK से ही पाठों को बुकमार्क कर सकते हैं।"
                      : null}{" "}
                    <ul>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Acts like a digital teaching diary. "
                          : lang === "hi"
                          ? "यह एक डिजिटल शिक्षण डायरी की तरह काम करता है।"
                          : null}{" "}
                      </li>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Helps in lesson planning and revision."
                          : lang === "hi"
                          ? "पाठ योजना और पुनरावृत्ति में मदद करता है।"
                          : null}{" "}
                      </li>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Easy to guide students by sharing highlights."
                          : lang === "hi"
                          ? "हाइलाइट्स साझा करके छात्रों का मार्गदर्शन करना आसान है।"
                          : null}{" "}
                      </li>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Improves classroom organization."
                          : lang === "hi"
                          ? "कक्षा की व्यवस्था में सुधार करता है।"
                          : null}{" "}
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData5} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    <video
                      ref={v5}
                      onPlay={() => pauseOthers(v5.current)}
                      className="video-css"
                      width="540"
                      controls
                    >
                      <source
                        src={
                          "https://cdn.katbook.com/assets/sites/ncert/758982373915365376_PERSONALISATIONT5.mp4"
                        }
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    3.{" "}
                    {lang === "en"
                      ? "Inbuilt Dictionary & Translator"
                      : lang === "hi"
                      ? "अंतरनिर्मित शब्‍दकोश और अनुवादक "
                      : null}{" "}
                    <FaLanguage size={"25px"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {lang === "en"
                      ? "Teachers can simply highlight any word for instant meaning from the in-built dictionary to make children understand the meaning of difficult terms. With an in-built translator, teachers can translate the entire book or even particular words/text in the preferred language of the region. No external apps needed."
                      : lang === "hi"
                      ? "शिक्षक इनबिल्ट शब्‍दकोश  से किसी भी शब्द का तुरंत अर्थ चुनकर उसे हाइलाइट कर सकते हैं ताकि बच्चे मुश्किल शब्दों का अर्थ समझ सकें। अंतरनिर्मित अनुवादक  की मदद से, शिक्षक पूरी किताब या यहाँ तक कि किसी खास शब्द/पाठ का भी उस क्षेत्र की पसंदीदा भाषा में अनुवाद कर सकते हैं। किसी बाहरी ऐप की सहायता के बिना । "
                      : null}{" "}
                    <ul>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Improves vocabulary and comprehension."
                          : lang === "hi"
                          ? "शब्दावली और समझ में सुधार करता है।"
                          : null}{" "}
                      </li>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Helps in learning without external help."
                          : lang === "hi"
                          ? "बिना किसी बाहरी मदद के सीखने में मदद करता है।"
                          : null}{" "}
                      </li>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Supports bilingual learning."
                          : lang === "hi"
                          ? "द्विभाषी शिक्षण को बढ़ावा देता है।"
                          : null}{" "}
                      </li>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Bridges gaps in diverse classrooms."
                          : lang === "hi"
                          ? "विविध कक्षाओं में अंतर को पाटता है।"
                          : null}{" "}
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData6} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    <video
                      ref={v6}
                      className="video-css"
                      width="540"
                      controls
                      onPlay={() => pauseOthers(v6.current)}
                    >
                      <source
                        src={
                          "https://cdn.katbook.com/assets/sites/ncert/758982476378017792_DictionaryTranslateT6.mp4"
                        }
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    4.{" "}
                    {lang === "en"
                      ? "AI Search"
                      : lang === "hi"
                      ? "एआई द्वारा खोज / ए आई सर्च "
                      : null}{" "}
                    <img src={aisearch} width={"2%"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {lang === "en"
                      ? "Another revolutionary feature in-built in the KATBOOK is AI Search. With the help of AI Search, teachers can highlight any part of the book and ask various AI Modules to generate a summary or synopsis for that particular highlighted part of the book. They can even generate Q&A or any other specific information that you may seek."
                      : lang === "hi"
                      ? "कैटबुक में अंतर्निहित एक और क्रांतिकारी विशेषता एआई सर्च है। एआई सर्च की मदद से, शिक्षक पुस्तक के किसी भी भाग को हाइलाइट कर सकते हैं और विभिन्न एआई मॉड्यूल्स से पुस्तक के उस विशेष हाइलाइट किए गए भाग का सारांश या सिनॉप्सिस तैयार करने के लिए कह सकते हैं। वे प्रश्नोत्तर या कोई अन्य विशिष्ट जानकारी भी तैयार कर सकते हैं जिसकी आपको आवश्यकता हो।"
                      : null}{" "}
                    <ul>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Quick fact-checking during class. "
                          : lang === "hi"
                          ? "कक्षा के दौरान त्वरित तथ्य-जांच।"
                          : null}{" "}
                      </li>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Access to multiple resources in one place. "
                          : lang === "hi"
                          ? "एक ही स्थान पर कई संसाधनों तक पहुँच।"
                          : null}{" "}
                      </li>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Improves lesson enrichment."
                          : lang === "hi"
                          ? "पाठ को समृद्ध बनाता है।"
                          : null}{" "}
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData7} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    <video
                      ref={v7}
                      onPlay={() => pauseOthers(v7.current)}
                      className="video-css"
                      width="540"
                      controls
                    >
                      <source
                        src={
                          "https://cdn.katbook.com/assets/sites/ncert/758982374192189440_AISEARCHT7.mp4"
                        }
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    5.{" "}
                    {lang === "en"
                      ? "Coverage Report"
                      : lang === "hi"
                      ? "आवृत्‍त क्षेत्र की रिपोर्ट / कवरेज रिपोर्ट "
                      : null}{" "}
                    <img src={coverage} width={"2%"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {lang === "en"
                      ? "  Once connected with KAMPUS during a full scale roll-out on a school level, Teachers will be able to see chapter coverage, exercises completed, and overall book progress for each student in her dashboard. "
                      : lang === "hi"
                      ? "स्कूल स्तर पर पूर्ण पैमाने पर रोल-आउट के दौरान KAMPUS से जुड़ने के बाद, शिक्षक अपने डैशबोर्ड में प्रत्येक छात्र के अध्याय कवरेज, पूर्ण किए गए अभ्यास और पुस्तक की समग्र प्रगति देख सकते हैं।"
                      : null}{" "}
                    <ul>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Tracks class progress automatically."
                          : lang === "hi"
                          ? "कक्षा की प्रगति को स्वचालित रूप से ट्रैक करता है।"
                          : null}{" "}
                      </li>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Identifies weaker learners early. "
                          : lang === "hi"
                          ? "कमज़ोर शिक्षार्थियों की शीघ्र पहचान करता है।"
                          : null}{" "}
                      </li>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Supports data-driven teaching."
                          : lang === "hi"
                          ? "डेटा-आधारित शिक्षण का समर्थन करता है।"
                          : null}{" "}
                      </li>
                      <li>
                        {" "}
                        {lang === "en"
                          ? "Ensures syllabus completion on time."
                          : lang === "hi"
                          ? "समय पर पाठ्यक्रम पूरा करना सुनिश्चित करता है।"
                          : null}{" "}
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData8} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    <video
                      ref={v8}
                      onPlay={() => pauseOthers(v8.current)}
                      className="video-css"
                      width="540"
                      controls
                    >
                      <source
                        src={
                          "https://cdn.katbook.com/assets/sites/ncert/758982476042473472_CoveragereportT8.mp4"
                        }
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className="d-flex flex-column gap-3">
                  <div className="cont-heading">
                    6.{" "}
                    {lang === "en"
                      ? "Multiple Search"
                      : lang === "hi"
                      ? "मल्टीपल सर्च "
                      : null}{" "}
                    <img src={mul_search} width={"2%"} className="nonemobi" />
                  </div>
                  <div className="cont-para d-flex flex-column gap-2">
                    {lang === "en"
                      ? "In case the teacher wants more information on any particular subject that is not available as additional content, we have provided the KATBOOK with a revolutionary MULTIPLE SEARCH FEATURE. Teachers can highlight and select any word or any part of the text from the KATBOOK and navigate to multiple search option where they can find information from multiple sources: "
                      : lang === "hi"
                      ? "यदि शिक्षक किसी विशेष विषय पर अधिक जानकारी चाहते हैं जो अतिरिक्त सामग्री के रूप में उपलब्ध नहीं है, तो हमने KATBOOK में एक क्रांतिकारी मल्टीपल (विविध प्रकार की) सर्च सुविधा प्रदान की है। शिक्षक KATBOOK से किसी भी शब्द या पाठ के किसी भी भाग को हाइलाइट और चुन सकते हैं और मल्टीपल सर्च विकल्प पर जा सकते हैं जहाँ वे विभिन्न स्रोतों से जानकारी प्राप्त कर सकते हैं:"
                      : null}{" "}
                    <ul>
                      <li>
                        {lang === "en"
                          ? "Various AIs like chatgpt, gemini, perplexity etc."
                          : lang === "hi"
                          ? "विभिन्न AI जैसे चैटजीपीटी, जेमिनी, पेरप्लेक्सिटी आदि।"
                          : null}{" "}
                      </li>
                      <li>
                        {lang === "en"
                          ? "Various Web Browsers."
                          : lang === "hi"
                          ? "विभिन्न वेब ब्राउज़र"
                          : null}{" "}
                      </li>
                      <li>
                        {lang === "en"
                          ? "Various Encyclopedias like wikipedia, brittanica."
                          : lang === "hi"
                          ? "विभिन्न विश्वकोश जैसे विकिपीडिया, ब्रिटानिका"
                          : null}{" "}
                      </li>
                      <li>
                        {lang === "en"
                          ? "Various dictionaries like merriam or oxford."
                          : lang === "hi"
                          ? "विभिन्न शब्दकोश जैसे मेरियम या ऑक्सफ़ोर्ड"
                          : null}{" "}
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="diutexh w-100">
                  {/* img */}
                  <div className="width_Video">
                    <Carousel items={sampleData9} />
                  </div>

                  {/* Video */}
                  <div className="width_Video">
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video
                      ref={v9}
                      onPlay={() => pauseOthers(v9.current)}
                      className="video-css"
                      width="540"
                      controls
                    >
                      <source
                        src={
                          "https://cdn.katbook.com/assets/sites/ncert/758982343548604416_MULTIPLESEARCHT9.mp4"
                        }
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex flex-column align-items-start gap-3 pt-5 pb-3">
            <div className="meta-font">
              {lang === "en"
                ? "TEACHER’S HANDBOOK"
                : lang === "hi"
                ? "शिक्षक पुस्तिका"
                : null}{" "}
            </div>
            <div className="text-foun-font">
              {lang === "en"
                ? "UTeach version of KATBOOK comes with a built-in Teacher’s Handbook section if provided by the board. Accessible via KATBOOK, it includes lesson objectives, suggested teaching strategies, activity ideas, assessment guidelines, and tips for differentiated instruction."
                : lang === "hi"
                ? "यदि बोर्ड द्वारा प्रदान किया गया हो, तो KATBOOK का UTeach संस्करण एक अंतर्निहित शिक्षक पुस्तिका अनुभाग के साथ आता है। KATBOOK के माध्यम से सुलभ, इसमें पाठ के उद्देश्य, सुझाई गई शिक्षण रणनीतियाँ, गतिविधि के विचार, मूल्यांकन दिशानिर्देश और विभेदित निर्देश के लिए सुझाव शामिल हैं।"
                : null}{" "}
            </div>
            <div className="meta-font">
              {lang === "en"
                ? "Benefits for Teachers"
                : lang === "hi"
                ? "शिक्षकों के लिए लाभ"
                : null}{" "}
            </div>
            <div className="cont-para d-flex flex-column gap-2">
              <ul>
                <li>
                  {lang === "en"
                    ? "Acts as a ready-made teaching guide aligned with curriculum standards."
                    : lang === "hi"
                    ? "पाठ्यक्रम मानकों के अनुरूप एक तैयार शिक्षण मार्गदर्शिका के रूप में कार्य करता है।"
                    : null}{" "}
                </li>
                <li>
                  {lang === "en"
                    ? "Supports new or less experienced teachers with step-by-step guidance."
                    : lang === "hi"
                    ? "नए या कम अनुभवी शिक्षकों को चरण-दर-चरण मार्गदर्शन प्रदान करता है।"
                    : null}{" "}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div>
        <Footer
          setActiveTab={setActiveTabHeader}
          RoutesClick={RoutesClick}
          NcertClick={NcertClick}
        />
      </div>
    </div>
  );
};

export default UTeachFoundation;
